import axios from "axios";

// Same origin unless REACT_APP_BACKEND_URL is set at build time (Emergent set it; this machine serves site and API together).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const fetchPosts = (params = {}) => api.get("/blog/posts", { params }).then((r) => r.data);
export const fetchPost = (slug) => api.get(`/blog/posts/${slug}`).then((r) => r.data);
export const fetchCategories = () => api.get("/blog/categories").then((r) => r.data);
export const subscribeNewsletter = (email, source = "site") =>
  api.post("/newsletter", { email, source }).then((r) => r.data);
export const submitConsultation = (payload) =>
  api.post("/consultations", payload).then((r) => r.data);
export const submitNetworkApplication = (payload) =>
  api.post("/network/apply", payload).then((r) => r.data);
export const fetchBriefList = () => api.get("/brief/list").then((r) => r.data);
export const fetchBrief = (id) => api.get(`/brief/${id}`).then((r) => r.data);

// What to tell a visitor when a public form is refused, by HTTP status.
export function formError(err, email) {
  const status = err?.response?.status;
  if (status === 429) return "Too many attempts from this connection. Please wait ten minutes and try again.";
  if (status === 422) {
    const d = err.response.data?.detail;
    if (typeof d === "string") return d;
    return "Something in the form is missing or too long. Please check it and try again.";
  }
  return `Could not send. Please try again, or email ${email}.`;
}
